/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { domainsCheckHealth } from "../funcs/domainsCheckHealth.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { CustomDomain } from "../models/components/customdomain.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CheckDomainHealthRequest,
  CheckDomainHealthSecurity,
} from "../models/operations/checkdomainhealth.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CheckDomainHealthMutationVariables = {
  request?: CheckDomainHealthRequest | undefined;
  security?: CheckDomainHealthSecurity | undefined;
  options?: RequestOptions;
};

export type CheckDomainHealthMutationData = CustomDomain;

export type CheckDomainHealthMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * checkHealth domains
 *
 * @remarks
 * Check the routing and certificate health of the organization's custom domain
 */
export function useCheckDomainHealthMutation(
  options?: MutationHookOptions<
    CheckDomainHealthMutationData,
    CheckDomainHealthMutationError,
    CheckDomainHealthMutationVariables
  >,
): UseMutationResult<
  CheckDomainHealthMutationData,
  CheckDomainHealthMutationError,
  CheckDomainHealthMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCheckDomainHealthMutation(client, options),
    ...options,
  });
}

export function mutationKeyCheckDomainHealth(): MutationKey {
  return ["@gram/client", "domains", "checkHealth"];
}

export function buildCheckDomainHealthMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CheckDomainHealthMutationVariables,
  ) => Promise<CheckDomainHealthMutationData>;
} {
  return {
    mutationKey: mutationKeyCheckDomainHealth(),
    mutationFn: function checkDomainHealthMutationFn({
      request,
      security,
      options,
    }): Promise<CheckDomainHealthMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(domainsCheckHealth(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
